// extracted by mini-css-extract-plugin
export default {"main":"HowSection_main__6dS-2","howContainer":"HowSection_howContainer__rPMzg","cardGrid":"HowSection_cardGrid__pbJTQ"};